import { isNil } from 'ramda';

import {
  EmployerCostSettingFlagForm,
  EmployerCostSettingResponse,
  EmployerCostSettingsFormValues
} from '../types';

import { convertFlagsArrayToObjects } from 'utils/misc';

import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';

import { useGetEmployerCostSetting } from '../hooks/useGetEmployerCostSetting';
import EmployerCostSettingsForm from './EmployerCostSettingsForm';
import { EmployerCostSettingsSkeleton } from './EmployerCostSettingsSkeleton';

interface Props {
  isCopy: boolean;
}

const convertRequestToFormData = (
  data: EmployerCostSettingResponse
): EmployerCostSettingsFormValues => {
  return {
    ...data,
    flags: convertFlagsArrayToObjects<EmployerCostSettingFlagForm>(data.flags)
  };
};

const EmployerCostSettings = ({
  handleClose,
  rowId,
  ...props
}: FormComponentProps & Props) => {
  const { isFetching, data } = useGetEmployerCostSetting(
    !isNil(rowId) ? Number(rowId) : rowId
  );

  return (
    <>
      {isFetching ? (
        <EmployerCostSettingsSkeleton />
      ) : (
        <EmployerCostSettingsForm
          data={data ? convertRequestToFormData(data) : undefined}
          handleClose={handleClose}
          isCopy={props.isCopy}
        />
      )}
    </>
  );
};

export default EmployerCostSettings;
